import { createContext } from 'react';
import { Job } from '@/types/api';

type JobPagesContext = {
  refetchJob: () => void;
  job?: Job;
  isLoadingJob: boolean;
};

const context = createContext<JobPagesContext>({
  refetchJob() {},
  isLoadingJob: false,
});

export default context;
